<template>
  <MobileNavPanel
    :key="'main'"
    class="flex h-full min-w-full shrink-0 flex-col justify-between"
  >
    <ul class="flex flex-col gap-y-5 overflow-hidden p-4">
      <li
        v-for="item in navigationItems"
        :key="item.key"
        class="flex min-h-[88px] cursor-pointer items-center rounded-lg bg-gray-200 px-4"
        data-testid="mobile-nav-link-main"
        @click="handleClick(item.label)"
      >
        <a
          class="rounded font-rubik !text-xl !font-medium !text-gray-600 transition-all supports-hover:hover:bg-[var(--backgroundColor)]"
        >
          {{ item.label }}
        </a>
      </li>
    </ul>

    <SFMobileHeaderUserArea />
  </MobileNavPanel>
</template>

<script lang="ts" setup>
import MobileNavPanel from './MobileNavPanel.vue'
import SFMobileHeaderUserArea from '~/components/layout/headers/SFMobileHeaderUserArea.vue'
import { useTopNavigationMenu } from '~/composables/useTopNavigationMenu'
import { useGenderMenuItems } from '~/composables/useGenderMenuItems'

const { genderMenuItems: navigationItems } = useGenderMenuItems()

const { setCurrentMenu } = useTopNavigationMenu()

const handleClick = (item: string) => setCurrentMenu(item)
</script>
